import Overview from '../../../modules/classification/components/overview/containers/overview';

export default {
  path: ':organization/classification',
  indexRoute: { component: Overview },
  title: 'Classification',
};
